import _ from 'lodash';
import axios from 'axios';
import environment from '@src/environment';

export const state = {
  preferences: [],
  preferenceCategories: [],
  userProfile: {},
};

export const getters = {
  onboardingComplete(state) {
    return JSON.parse(window.localStorage.getItem('onboardingComplete'));
  },
};

export const mutations = {
  setUserProfile(state, newValue) {
    window.localStorage.setItem('onboardingComplete', newValue.onboardingComplete);
    state.userProfile = newValue;
  },
  setPreferences(state, newValue) {
    state.preferences = newValue;
  },
  setPreferenceCategories(state, newValue) {
    state.preferenceCategories = newValue;
  },
};

export const actions = {
  async getUserProfile(ctx) {
    return await axios
      .get(environment.GET_USER_PROFILE_URL)
      .then((response) => {
        ctx.commit('setUserProfile', response.data);
        return response.data;
      })
      .catch((err) => {
        console.log(err);
        return { err: 'Unable to get user profile' };
      });
  },

  async updateUserProfile(ctx, payload) {
    if (payload) {
      return await axios
        .post(environment.UPDATE_USER_PROFILE_URL, payload)
        .then((response) => ctx.commit('setUserProfile', response.data))
        .catch((err) => {
          console.log(err);
          return { err: 'Unable to update user profile' };
        });
    }
  },

  async getPreferenceCategories(ctx, {} = {}) {
    return await axios
      .get(`${environment.GET_PREFERENCE_CATEGORIES}`)
      .then((res) => ctx.commit('setPreferenceCategories', res.data))
      .catch((err) => console.log(err));
  },

  async getPreferences(ctx, { categoryId = '' } = {}) {
    if (!ctx.state.preferences.length) {
      return await axios
        .get(`${environment.GET_PREFERENCES}?preferenceCategoryId=${categoryId}`)
        .then((res) => ctx.commit('setPreferences', res.data))
        .catch((err) => console.log(err));
    }
  },

  async updatePreferences(ctx, { preferences } = {}) {
    const payload = _.map(preferences, _.partialRight(_.pick, ['id', 'isSelected']));

    return await axios
      .post(`${environment.UPDATE_PREFERENCES}`, payload)
      .then((res) => {
        if (!ctx.state.userProfile.onboardingComplete) {
          ctx.dispatch('updateUserProfile', { ...ctx.state.userProfile, onboardingComplete: true });
        }
      })
      .catch((err) => console.log(err));
  },
};
